import { CheckoutElementWrapper } from "@/wrappers/CheckoutElementWrapper";
import { DonationButtonWrapper } from "@/wrappers/DonationButtonWrapper";
import {CartItemsCounterWrapper} from "@/wrappers/CartItemsCounter"
import { r2wcStyled } from "./styledWCWrapper";


const CheckoutComponent = r2wcStyled(CheckoutElementWrapper, { 
  shadow: "open", 
  props: {
    open: "boolean",
    legacy: "boolean",
    onClose: 'function',
    onError: 'function'
  }
}) as any;
customElements.define("n3o-checkout", CheckoutComponent);

const CartItemsCounterComponent = r2wcStyled(CartItemsCounterWrapper, { 
  shadow: "open"
}) as any;
customElements.define("n3o-cart-items-count", CartItemsCounterComponent);

const DonationComponent = r2wcStyled(DonationButtonWrapper, { 
  shadow: "open", 
  props: {
    subscriptionId: "string",
    onError: 'function',
    amount: 'number',
    currency: 'string',
    onSuccess: 'function',
  }
}) as any;
customElements.define("n3o-donation-button", DonationComponent);